import React from 'react';

import { FILTER_TYPES, PAGE_SIZE_FILTER } from 'constants/filterType';
import { productBrandNameApi } from 'api';

export const VENDOR_FILTER_OPTIONS = [
  {
    field: 'vendor_code__icontains',
    label: 'Vendor Code',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'name__icontains',
    label: 'Vendor Name',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'brand',
    label: 'Brand',
    type: FILTER_TYPES.SEARCH,
    apiService: productBrandNameApi,
    valueField: 'id',
    searchField: 'name__icontains',
    renderItem: item => <div className="font-medium">{item.name}</div>,
  },
  {
    field: 'contact_email__icontains',
    label: 'Email',
    type: FILTER_TYPES.TEXT,
  },
  { ...PAGE_SIZE_FILTER },
];

export const VENDOR_ITEM_FILTER_OPTIONS = [
  {
    field: 'product__sku__icontains',
    label: 'SKU',
    type: FILTER_TYPES.TEXT,
  },
  {
    field: 'product__brand__name__icontains',
    label: 'Brand',
    type: FILTER_TYPES.TEXT,
  },
  { ...PAGE_SIZE_FILTER },
];
